<a *ngIf="pill" class="fhp" [routerLink]="[pill.link]" (click)="pick.emit(pill)" data-test="fiscal-home-pill">
    <span class="fhp__icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2h12v20l-3-2-3 2-3-2-3 2z M9 7h6 M9 11h6 M9 15h4" />
        </svg>
    </span>
    <span class="fhp__label">{{ pill.label }}</span>
    <span *ngIf="pill.chip" class="fhp__chip" [ngClass]="'fhp__chip--' + pill.tone" data-test="fiscal-home-pill-chip">{{ pill.chip }}</span>
    <span class="fhp__arrow" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14 M13 6l6 6-6 6" />
        </svg>
    </span>
</a>
